module.exports = __webpack_public_path__ + "static/media/p2p.6de1400d.png";


//////////////////
// WEBPACK FOOTER
// ./src/steps/communicate-4/p2p.png
// module id = 587
// module chunks = 0